import RootDev from './Root.dev';
import RootProd from './Root.prod';

// Pick the dev/prod Root at runtime. Both are statically imported (webpack already
// bundled both branches of the old require()-switch), so this is bundle-neutral and
// gives a properly typed default export for index.tsx.
const Root = process.env.NODE_ENV === 'production' ? RootProd : RootDev;

export default Root;
